import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-idiomas',
    templateUrl: './idiomas.component.html',
    styleUrls: ['./idiomas.component.scss'],
})
export class IdiomasComponent implements OnInit {

    @Input() noUe: boolean = false;
    @Output() idiomaSelected: EventEmitter<any> = new EventEmitter();
    @Output() padraoSelected: EventEmitter<any> = new EventEmitter();

    language = 'pt';
    padrao = 'br';

    aberto: boolean;
    selecionado: any;

    idiomas = [
        {
            abreviacao: 'BRA',
            nome: 'Português',
            icone: '/assets/imgs/idiomas/pt.svg',
            slug: 'pt'
        },
        {
            abreviacao: 'EUA',
            nome: 'English',
            icone: '/assets/imgs/idiomas/en.png',
            slug: 'en'
        },
        {
            abreviacao: 'ES',
            nome: 'Espanol',
            icone: '/assets/imgs/idiomas/es.png',
            slug: 'es'
        }
    ];

    padroes = [
        {
            nome: 'Brasil',
            icone: '/assets/imgs/idiomas/pt.svg',
            slug: 'br'
        },
        {
            nome: 'União Européia',
            icone: '/assets/imgs/idiomas/ue.png',
            slug: 'ue'
        }
    ];

    constructor(
        private translate: TranslateService
    ) { }

    ngOnInit() {



        this.language = localStorage.getItem('LANGUAGE');
        console.log('language', this.language);
        this.padrao = localStorage.getItem('PADRAO');

        if (!this.language || !this.padrao) {
            localStorage.setItem('LANGUAGE', 'pt');
            localStorage.setItem('PADRAO', 'br');
            this.language = 'pt';
            this.padrao = 'br';
        }

        this.selecionado = this.idiomas.filter((i) => {
            return i.slug === this.language;
        })[0];

        this.translate.setDefaultLang(this.language);

        console.log('=====NOUE===', this.noUe, this.padrao);

        if (this.noUe && this.padrao == 'ue') {
            this.alternarPadraoClicked(this.padroes[0]);
        }
    }

    toggleClicked() {
        this.aberto = !this.aberto;
    }

    alterarIdiomaClicked(idioma: any, emit = true) {
        this.selecionado = idioma;
        this.toggleClicked();
        console.log('language', idioma);
        localStorage.setItem('LANGUAGE', idioma.slug);
        if (emit) {
            this.idiomaSelected.emit(this.selecionado.slug);
        }
        this.translate.setDefaultLang(this.selecionado.slug);
    }

    alternarPadraoClicked(padrao: any) {
        this.padrao = padrao.slug;
        this.toggleClicked();

        localStorage.setItem('PADRAO', this.padrao);
        this.padraoSelected.emit(this.padrao);

        let idioma = this.idiomas[0];
        if (this.padrao == 'ue') {
            idioma = this.idiomas[1];
        }
        this.alterarIdiomaClicked(idioma, false);
    }
}
